import React from "react";

export default function StatCard({ label, value, sub, accent, testid }) {
  return (
    <div data-testid={testid} className="bg-white border border-[#D2E0E6] rounded-lg shadow-sm p-4 fade-up">
      <div className="text-[10px] uppercase tracking-[0.15em] text-[#7C949C] mb-2">{label}</div>
      <div className="mono text-2xl font-semibold leading-none" style={{ color: accent || "#0B2830" }}>
        {value}
      </div>
      {sub && <div className="text-xs text-[#47616B] mt-2">{sub}</div>}
    </div>
  );
}
